import { ReactElement, useState } from 'react';
import { Select } from '../SelectField';
import { getUserProfile } from 'helpers/userProfile';
import { useFilterContext } from '../../contexts/FilterContext';
import { useTranslation } from 'react-i18next';
import { FilterFieldsContainer } from './styles';
import { healthComfortOptions, statusComfortOptions, statusHealthOptions } from './constants';
import { FilterOptions, ViewOption } from '../../types';

interface FilterFieldsProps {
  filterOptions: FilterOptions;
}

export function FilterFields({
  filterOptions,
}: Readonly<FilterFieldsProps >): ReactElement | null {
  const [profile] = useState(getUserProfile);
  const {
    client,
    onSelectClient,
    onSelectOption,
    onSelectView,
    selectedOptions,
    viewOption,
  } = useFilterContext();
  const { t } = useTranslation();

  const hasClientInput = !!(profile.manageAllClients || profile.manageMultipleClients);

  function onSelectGroup(value: string): void {
    const units = filterOptions.groups.find((item) => item.value === value)?.units ?? [];

    onSelectOption('group', value, units);
  }

  return (
    <FilterFieldsContainer hasClientInput={hasClientInput}>
      {hasClientInput && (
        <Select
          options={filterOptions.clients}
          placeholder={t('selecionarCliente')}
          value={client}
          icon="User1Icon"
          onSelect={onSelectClient}
        />
      )}
      {client && (
        <>
          <Select
            icon={viewOption === 'health' ? 'ActivityIcon' : 'Thermometer2Icon'}
            options={healthComfortOptions}
            placeholder=""
            value={viewOption}
            onSelect={(value) => onSelectView(value as ViewOption)}
          />
          <Select
            icon="BookmarkIcon"
            options={
              viewOption === 'health'
                ? statusHealthOptions
                : statusComfortOptions
            }
            placeholder={t('selecionarStatus')}
            value={viewOption === 'health' ? selectedOptions.healthStatus : selectedOptions.status}
            onSelect={(value) => onSelectOption(viewOption === 'health' ? 'healthStatus' : 'status', value)}
          />
          <Select
            icon="MarkerPin1Icon"
            options={filterOptions.states}
            placeholder={t('selecionarEstado')}
            value={selectedOptions.state}
            onSelect={(value) => onSelectOption('state', value)}
            multiple
          />
          {!profile.manageAllClients && filterOptions.groups.length > 0 && (
            <Select
              icon="LayoutGrid1Icon"
              options={filterOptions.groups}
              placeholder={t('selecionarGrupo')}
              value={selectedOptions.group?.value}
              onSelect={onSelectGroup}
            />
          )}
        </>
      )}
    </FilterFieldsContainer>
  );
}
